module.exports = __webpack_public_path__ + "static/media/home__kyc-photos.9044d8b8.png";